import { Component, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { ReplaceableComponentsService, DynamicLayoutComponent } from '@abp/ng.core';
import { eThemeLeptonComponents } from '@volo/abp.ng.theme.lepton';
import { CustomFooterComponent } from './shared/custom-footer/custom-footer.component';
import { SettingTabsService } from '@abp/ng.setting-management/config';
import { SmtpServerSettingsComponent } from './settings/smtp-server-settings/smtp-server-settings.component';
import { AgentUpdateSettingsComponent } from './settings/agent-update-settings/agent-update-settings.component';
import { ContinuousPstScanSettingsComponent } from './settings/continuous-pst-scan-settings/continuous-pst-scan-settings.component';
import { Subscription } from 'rxjs';
import { LoaderBarComponent, InternetConnectionStatusComponent } from '@abp/ng.theme.shared';
import { GdprCookieConsentComponent } from '@volo/abp.ng.gdpr/config';

@Component({
  selector: 'app-root',
  standalone: true,
  template: `
    <abp-loader-bar></abp-loader-bar>
    <abp-dynamic-layout></abp-dynamic-layout>
    <abp-gdpr-cookie-consent></abp-gdpr-cookie-consent>
    <abp-internet-status></abp-internet-status>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    LoaderBarComponent,
    DynamicLayoutComponent,
    GdprCookieConsentComponent,
    InternetConnectionStatusComponent,
  ],
})
export class AppComponent implements OnDestroy {
  private readonly tokenRefreshInterval: Subscription | null = null;
  constructor(
    private readonly replaceableComponents: ReplaceableComponentsService,
    private readonly settingTabs: SettingTabsService,
  ) {
    this.replaceableComponents.add({
      component: CustomFooterComponent,
      key: eThemeLeptonComponents.ApplicationLayoutFooter,
    });

    // added below
    settingTabs.add([
      {
        name: '::SMTP Server Settings',
        order: 101,
        requiredPolicy: 'AbpAccount.SMTPServerSettings',
        component: SmtpServerSettingsComponent,
      },
      {
        name: '::AgentUpdates',
        order: 102,
        requiredPolicy: 'AbpAccount.AgentUpdateSettings',
        component: AgentUpdateSettingsComponent,
      },
      {
        name: '::PSTDiscoverySettings',
        order: 103,
        requiredPolicy: 'AbpAccount.PSTScanSettings',
        component: ContinuousPstScanSettingsComponent,
      },
    ]);
  }

  ngOnDestroy() {
    if (this.tokenRefreshInterval) {
      this.tokenRefreshInterval.unsubscribe();
    }
  }
}
